module.exports = "/_next/static/images/SizeID_about_jump-2f27a4dcfd2e972291597da8af1159a8.svg";